// @core
import { i18n } from "core/i18n";
import PropTypes from "prop-types";

// @components
import SummaryList from "components/commons/summaryList/summaryList";
import SummaryListItem from "components/commons/summaryListItem/summaryListItem";
import { OKMessage, MESSAGE_TYPE_ASSISTANT } from 'commonsComponents/OKMessage'
import ContactCenterRender from "components/conditionalRender/contactCenterRender"

// @helpers
import { getConfirmationResume } from "../../helpers/bringAccountHelper";

// @constants
const { FormattedText, formatText } = i18n;

import './transferSummaryStep.scss';

const TransferResumeRight = ({ hasEntityFound, destinationAccount, executionDate }) => {
    return (
        <div>
            {
                hasEntityFound && (
                    <SummaryListItem
                        text={formatText('transfer_account-transfer_account_from_another_bank_step4_execution_date')}
                        value={executionDate}
                    />
                )
            }
            <SummaryListItem
                text={formatText('transfer_account-transfer_account_from_another_bank_step4_destiny_account')}
                value={destinationAccount}
            />
        </div>
    )
}

const TransferResumeLeft = ({ hasEntityFound, originAccount, executionDate, originEntity }) => {
    return (
        <>
            <SummaryListItem
                text={formatText('transfer_account-transfer_account_from_another_bank_step4_origin_account')}
                value={originAccount}
            />
            {
                hasEntityFound
                    ? (
                        <SummaryListItem
                            text={formatText('transfer_account-transfer_account_from_another_bank_step4_origin_entity')}
                            value={originEntity}
                        />
                    )
                    : (
                        <SummaryListItem
                            text={formatText('transfer_account-transfer_account_from_another_bank_step4_execution_date')}
                            value={executionDate}
                        />
                    )
            }
        </>
    );
}

export const TransferSummaryStep = ({ immAccount, isOffice, immBringAccount }) => {
    const { destinationAccount, originAccount, originEntity, executionDate } = getConfirmationResume(immAccount, immBringAccount);
    const hasEntityFound = !!originEntity

    const disclaimerDescription = isOffice
        ? 'transfer_account_oficina-transfer_account_from_another_bank_step4_disclaimer_of'
        : 'transfer_account_cc-transfer_account_from_another_bank_step4_disclaimer_cc'

    return (
        <div className="transfer-account__transfer-resume">
            <section className='transfer-account__transfer-resume__summary'>
                <h2 className='transfer-account__transfer-resume__title'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step4_confirmation_title" />
                </h2>
                <p className='transfer-account__transfer-resume__subtitle'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step4_confirmation_subtitle" />
                </p>

                <ContactCenterRender>
                    <div className="transfer-account__transfer-resume__disclaimer">
                        <OKMessage type={MESSAGE_TYPE_ASSISTANT}>
                            <FormattedText value={disclaimerDescription} />
                        </OKMessage>
                    </div>
                </ContactCenterRender>

                <section className='transfer-account__transfer-resume__summary-data'>
                    <SummaryList
                        rightColumn={(
                            <TransferResumeRight
                                hasEntityFound={hasEntityFound}
                                destinationAccount={destinationAccount}
                                executionDate={executionDate}
                            />
                        )}
                        leftColumn={(
                            <TransferResumeLeft
                                hasEntityFound={hasEntityFound}
                                originAccount={originAccount}
                                originEntity={originEntity}
                                executionDate={executionDate}
                            />
                        )}
                    />
                </section>
            </section>
        </div>
    );
}

TransferSummaryStep.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immBringAccount: PropTypes.object.isRequired,
    isOffice: PropTypes.bool.isRequired,
}
